import {inject, Injectable} from '@angular/core';
import {UploadProgressService} from "../../../../../../core/services/upload-progress.service";
import {ErrorService} from "../../../../../../core/services/error.service";
import {FileParams} from "../../../../../../core/types/file.types";
import {HttpEventType} from "@angular/common/http";
import {defaultFileParams} from "../../../../../../core/models/default-file-params";
import {ProgressStatus} from "../../../../../../core/types/upload-progress.types";
import {UploadPackagesExcelApiService} from "./upload-packages-excel-api.service";
import {UploadProductPackagesExcelParams} from "../types/upload-packages-excel.types";

@Injectable({
  providedIn: 'root'
})
export class UploadPackagesExcelService {
  private uploadPackagesExcelApiService: UploadPackagesExcelApiService = inject(UploadPackagesExcelApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private errorService: ErrorService = inject(ErrorService);

  public async importProductPackagesExcel(uploadProductPackagesExcelParams: UploadProductPackagesExcelParams): Promise<FileParams> {
    return new Promise((resolve, reject) => {
      this.uploadPackagesExcelApiService.importProductPackagesExcel(uploadProductPackagesExcelParams).subscribe({
        next: (event) => {
          const progress = this.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: uploadProductPackagesExcelParams.fileName,
            fileType: 'file',
          });

          if (event.type === HttpEventType.Response) {
            setTimeout(() => {
              const fileParams = event.body;
              resolve(fileParams || defaultFileParams);
              this.uploadProgressService.resetProgress();
            }, 300);
          }
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        }
      });
    });
  }

  private handleUploadEvent(event: any): ProgressStatus {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        const progress = Math.round(100 * event.loaded / (event.total || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
